import React     from 'react';
import TextInput from './TextInput';

const ParametersChanged = ({ parametersChanged }) => (
  <TextInput
    type="hidden"
    name="parameters_changed"
    inputClassName="parameter-changed"
    value={parametersChanged ? '1' : ''}
    groupName="" />
);

ParametersChanged.defaultProps = {
  required: true,
};

export default ParametersChanged;
